import Button from '@atlaskit/button';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import { ButtonClickedEvent, ModalRenderedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useParams } from '@atlassian/mpac-ui';
import React, { useEffect } from 'react';
import { ANALYTICS_SUBJECT_ID_TWO_SV_ANNOUNCEMENT_MODAL_CLOSE, ANALYTICS_SUBJECT_ID_TWO_SV_SESSION_TIMED_OUT_MODAL } from '../../../ManagePartners/analytics/Events';
import { twoStepSessionTimedOutModalMessage } from './TwoStepSessionTimedOutModal.constants';
const TwoStepSessionTimedOutModal = _ref => {
  let {
    setCancel
  } = _ref;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const params = useParams();
  useEffect(() => {
    fireAnalyticsEvent({
      eventType: ModalRenderedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_TWO_SV_SESSION_TIMED_OUT_MODAL,
      objectId: params.partnerId
    });
  }, []);
  const closeModal = () => {
    setCancel(false);
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_TWO_SV_ANNOUNCEMENT_MODAL_CLOSE,
      objectId: params.partnerId
    });
  };
  const reloadPage = () => {
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_TWO_SV_SESSION_TIMED_OUT_MODAL,
      objectId: params.partnerId
    });
    window.location.reload();
  };
  return /*#__PURE__*/React.createElement(ModalTransition, null, /*#__PURE__*/React.createElement(Modal, {
    width: "medium",
    testId: "two-fa-session-timed-out-modal"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, twoStepSessionTimedOutModalMessage.header)), /*#__PURE__*/React.createElement(ModalBody, null, twoStepSessionTimedOutModalMessage.body), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    appearance: "subtle",
    onClick: closeModal
  }, twoStepSessionTimedOutModalMessage.dismissCTA), /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    autoFocus: true,
    onClick: reloadPage
  }, twoStepSessionTimedOutModalMessage.cta))));
};
export default TwoStepSessionTimedOutModal;